<script setup>
import { Swiper, SwiperSlide } from 'swiper/vue';

import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import {computed} from "vue";

const props = defineProps({
  model: {
    type: Array,
    default: () => []
  },
  color: {
    type: String,
    default: 'orange'
  }
});


</script>

<template>
  <div class="slideshow-container-products-urbano">
    <swiper
      :slides-per-view="1"
      :space-between="20"
      :loop="true"
      :breakpoints="{
        '640': {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        '1024': {
          slidesPerView: 4,
          spaceBetween: 30,
        },
        }"
      class="mySwiperMenu">
      <template v-for="prod in model" :key="prod.id">
        <swiper-slide v-for="variant in prod.variationProducts" :key="variant.id">
          <a :href="variant.slug" class="slide-link">
            <div class="slide-card">
              <div class="image-wrapper">
                <img
                  v-if="variant.featured_image"
                  :src="variant.featured_image.fullUrl"
                  :alt="variant.name"
                  class="slide-img"/>
              </div>
              <div class="slide-info">
                <p class="name">
                  {{ variant.name }}
                  <span class="ref"
                        :class="{
                       'navy-color': variant.reference === 'Navy',
                       'mint-color' : variant.reference === 'Mint',
                       'pink-color' : variant.reference === 'Pink',
                       'snow-color' : variant.reference === 'Snow',}">
                    {{ variant.reference }}
                  </span>
                </p>
              </div>
            </div>
          </a>
        </swiper-slide>
      </template>
    </swiper>
  </div>
</template>

<style scoped>


</style>
